import React from 'react';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import TestimonialsSlider from './Slider';
import SectionIntro from '../../molecules/SectionIntro';

const Testimonials = () => {
  const { t } = useTranslation('common');

  return (
    <section className="bg-[#f8f5f0] py-16 md:py-24">
      <div id="testimonials-container">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-5xl lg:px-8">
          <SectionIntro title={t('service.home.testimonials.title')} />
          <div className="mt-8 pb-8">
            <div className="max-w-3xl mx-auto">
              <TestimonialsSlider />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default Testimonials;
